import { call, put, takeEvery } from "redux-saga/effects";
import { GET_RIDE_ANALYTICS, GET_RIDE_DETAILS, GET_TOTAL_REGISTRATION, GET_TOPCOMPANIES, GET_COMPANY_TRIP_STATS, GET_COMPANYDATA } from "resources/actionTypes";
import { rideAnalyticApi, rideDetailsApi, totalRegistrationApi,topCompaniesApi, companyTripStatsApi, companiesDataApi } from "services/DashboardService";

function* fetchRideDetails(action) {
  try {
    const payload = action.payload || {}
    const userRideDetails = yield call(rideDetailsApi, payload);
    yield put({ type: GET_RIDE_DETAILS.GET_RIDE_DETAILS_SUCCESS, userRideDetails: userRideDetails });
  } catch (e) {
    yield put({ type: GET_RIDE_DETAILS.GET_RIDE_DETAILS_FAILED, message: e.message });
  }
}

export function* userRideDetailsSaga() {
  yield takeEvery(GET_RIDE_DETAILS.GET_RIDE_DETAILS_REQUESTED, fetchRideDetails);
}

function* fetchTotalRegistration(action) {
  try {
    const payload = action.payload || {}
    const userTotalRegistration = yield call(totalRegistrationApi, payload);
    yield put({ type: GET_TOTAL_REGISTRATION.GET_TOTAL_REGISTRATION_SUCCESS, userTotalRegistration: userTotalRegistration });
  } catch (e) {
    yield put({ type: GET_TOTAL_REGISTRATION.GET_TOTAL_REGISTRATION_FAILED, message: e.message });
  }
}

export function* userTotalRegistrationSaga() {
  yield takeEvery(GET_TOTAL_REGISTRATION.GET_TOTAL_REGISTRATION_REQUESTED, fetchTotalRegistration);
}

function* fetchRideAnalytic(action) {
  try {
    const payload = action.payload || {}
    const userRideAnalytic = yield call(rideAnalyticApi, payload);
    yield put({ type: GET_RIDE_ANALYTICS.GET_RIDE_ANALYTICS_SUCCESS, userRideAnalytic: userRideAnalytic });
  } catch (e) {
    yield put({ type: GET_RIDE_ANALYTICS.GET_RIDE_ANALYTICS_FAILED, message: e.message });
  }
}

export function* userRideAnalyticSaga() {
  yield takeEvery(GET_RIDE_ANALYTICS.GET_RIDE_ANALYTICS_REQUESTED, fetchRideAnalytic);
}


function* fetchTopCompanies(action) {
  try {
    const payload = action.payload || {}
    const topCompanies = yield call(topCompaniesApi, payload);
    yield put({ type: GET_TOPCOMPANIES.GET_TOPCOMPANIES_SUCCESS, topCompanies: topCompanies });
  } catch (e) {
    yield put({ type: GET_TOPCOMPANIES.GET_TOPCOMPANIES_FAILED, message: e.message });
  }
}

export function* userTopCompaniesSaga() {
  yield takeEvery(GET_TOPCOMPANIES.GET_TOPCOMPANIES_REQUESTED, fetchTopCompanies);
}

function* fetchCompanyTripStats(action) {
  try {
    const payload = action.payload || {}
    const companyTripStats = yield call(companyTripStatsApi, payload);
    yield put({ type: GET_COMPANY_TRIP_STATS.GET_COMPANY_TRIP_STATS_SUCCESS, companyTripStats: companyTripStats });
  } catch (e) {
    yield put({ type: GET_COMPANY_TRIP_STATS.GET_COMPANY_TRIP_STATS_FAILED, message: e.message });
  }
}

export function* userCompanyTripStatsSaga() {
  yield takeEvery(GET_COMPANY_TRIP_STATS.GET_COMPANY_TRIP_STATS_REQUESTED, fetchCompanyTripStats);
}

function* fetchCompanyData(action) {
  try {
    const payload = action.payload || {}
    const companyData = yield call(companiesDataApi, payload);
    yield put({ type: GET_COMPANYDATA.GET_COMPANYDATA_SUCCESS, companyData: companyData });
  } catch (e) {
    yield put({ type: GET_COMPANYDATA.GET_COMPANYDATA_FAILED, message: e.message });
  }
}

export function* userCompanySaga() {
  yield takeEvery(GET_COMPANYDATA.GET_COMPANYDATA_REQUESTED, fetchCompanyData);
}